<template>
  <div class="scrollama">
    <slot />
  </div>
</template>

<script>
import "intersection-observer";
import Scrollama from "scrollama";

export default {
  name: "scrollama",

  data() {
    return {
      scroller: null
    };
  },

  mounted() {
    this.scroller = Scrollama();

    this.scroller
      .setup({ step: ".step" })
      .onStepEnter(response => this.$emit("step-enter", response));

    window.addEventListener("resize", this.scroller.resize);
  }
};
</script>

<style></style>
